export const uploadItemStatus = {
  waiting: 0,
  uploading: 1,
  done: 2,
  error: 3,
  errorProcessImage: 4,
  errorImageAlreadyExists: 5,
}

export const imageRejectReasons = {
  1: 'Rejected',
  2: 'Image with children',
  3: 'Facial recognition image',
  4: 'Protected site image',
  5: 'Protected brand image (logo, trademark)',
  6: 'Duplicate',
  7: 'Other',
}
